import { z } from "zod";
import { timestamp } from "./timestamp";

export const bettingEventStatus = z.object({
  awayScore: z.number(),
  homeScore: z.number(),
  eventType: z.string(),
  name: z.string(),
  periodScores: z.record(
    z.string(),
    z.object({
      awayScore: z.number(),
      homeScore: z.number(),
      number: z.number(),
      name: z.string().nullish(),
    }),
  ),
  // old data still have it as a string
  scheduledStartTime: z.union([timestamp, z.string()]).optional(),
  homeCompetitor: z
    .object({
      abbreviation: z.string(),
      iconUri: z.string().optional(),
      name: z.string(),
      nationality: z.string().optional(),
      type: z.enum(["PLAYER", "FRANCHISE"]),
    })
    .optional(),
  awayCompetitor: z
    .object({
      abbreviation: z.string(),
      iconUri: z.string().optional(),
      name: z.string(),
      nationality: z.string().optional(),
      type: z.enum(["PLAYER", "FRANCHISE"]),
    })
    .optional(),
});

export type BettingEventStatus = z.infer<typeof bettingEventStatus>;
